'use strict';

exports.__esModule = true;
exports.convertURLtoBase64 = exports.generateArrayModelsFromMaps = exports.generateMapsFromArrayModels = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Generate array maps from array models array
 * Input:
 * [
 *  {
 *   name: 'foo',
 *   desc: 'bar',
 *   languageId: 1
 *  },
 *  {
 *   name: 'bar',
 *   desc: 'foo',
 *   languageId: 2
 *  }
 * ]
 *
 * Output:
 * i.e:
 * {
 *    name: Map(),
 *    desc: Map(),
 * }
 *
 * Each map it's key will be languageId
 *  name.get(1) => 'foo'
 *  name.get(2) => 'bar'
 *
 * @param {array} arrayModels
 * @param {string} key
 * @param {array} fallbackKeys
 * @returns {object} generatedObject
 */
var generateMapsFromArrayModels = exports.generateMapsFromArrayModels = function generateMapsFromArrayModels() {
  var arrayModels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var key = arguments[1];
  var fallbackKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var generatedObject = {};

  // If the coming array is empty, create an empty maps
  if (!arrayModels || arrayModels.length === 0) {
    fallbackKeys.forEach(function (fallbackKey) {
      generatedObject[fallbackKey] = new Map();
    });
    return generatedObject;
  }

  // Looping through all arrayModels
  arrayModels.forEach(function (item) {
    Object.entries(item).forEach(function (_ref) {
      var itemKey = _ref[0],
          itemValue = _ref[1];

      // We don't return the compare key
      if (key === itemKey) return;

      // Get the last saved map
      var newValue = generatedObject[itemKey];

      // If the value doesn't exist, we create a new map
      if (!newValue) {
        newValue = new Map();
      }

      generatedObject[itemKey] = newValue.set(item[key], itemValue);
    });
  });

  // Create empty maps for expected fallbackKeys if their value === null
  // in arrayModels
  fallbackKeys.forEach(function (fallbackKey) {
    var isKeyGenerated = generatedObject[fallbackKey];
    if (!isKeyGenerated) {
      generatedObject[fallbackKey] = new Map();
    }
  });

  return generatedObject;
};

/**
 * Generate array maps from array models array
 * Input:
 * {
 *    name: Map(),
 *    desc: Map(),
 * }
 *
 * Output
 * [
 *  {
 *   name: 'foo',
 *   desc: 'bar',
 *   languageId: 1
 *  },
 *  {
 *   name: 'bar',
 *   desc: 'foo',
 *   languageId: 2
 *  }
 * ]
 *
 * @param {object} object
 * @param {string} key
 * @returns {array} arrayModels
 */
var generateArrayModelsFromMaps = exports.generateArrayModelsFromMaps = function generateArrayModelsFromMaps(maps, key) {
  var arrayModelsMap = new Map();
  var arrayModels = [];
  var sharedModels = {};

  // Loop through maps keys
  Object.entries(maps).forEach(function (_ref2) {
    var itemKey = _ref2[0],
        itemValue = _ref2[1];

    // If the current item is amp
    if (itemValue instanceof Map) {
      itemValue.forEach(function (mapValue, mapKey) {
        var _extends2;

        // Map key will be the main key for arrayModelsMap
        arrayModelsMap.set(mapKey, _extends({}, arrayModelsMap.get(mapKey), (_extends2 = {}, _extends2[itemKey] = mapValue, _extends2)));
      });
    } else {
      // If the item isn't a map, so it's value is shared across arrayModels
      sharedModels[itemKey] = itemValue;
    }
  });

  // Push map items into an Array
  arrayModelsMap.forEach(function (itemValue, itemKey) {
    var _extends3;

    arrayModels.push(_extends((_extends3 = {}, _extends3[key] = itemKey, _extends3), itemValue, sharedModels));
  });

  return arrayModels;
};

/**
 * Convert image url to base64
 * @param {string} url Image url
 * @returns {promise}
 */
var getBase64 = function getBase64(url) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function () {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      var dataURL = canvas.toDataURL('png');
      resolve(dataURL);
      canvas = null;
    };

    img.onerror = function () {
      reject();
    };

    img.src = url;
  });
};

/**
 * Converts an array of images urls to base64
 * @param {array<any>} images Array of images
 * @param {Function} iterator Iterator function
 * @returns {array<string>} base64
 */
var convertURLtoBase64 = exports.convertURLtoBase64 = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(images) {
    var iterator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (photo) {
      return photo;
    };
    var promises, base64;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            promises = images.map(function (image) {
              return getBase64(iterator(image));
            });
            _context.next = 3;
            return Promise.all(promises);

          case 3:
            base64 = _context.sent;
            return _context.abrupt('return', base64);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function convertURLtoBase64(_x3) {
    return _ref3.apply(this, arguments);
  };
}();